import { formattedPlayerName } from "@utils/name_utils";
import { Select, Typography } from "antd";
import "@styles/styles-PlayerOptions.css";

const { Text } = Typography;
const { Option } = Select;


export const PlayerOptions = ({ player, teamName, index, playersStatus }: IPlayerOptions) => {
    const latestStatusDate = playersStatus ? Object.keys(playersStatus[player.player_id]?.status || []).sort((a, b) => {
        const dateA = new Date(a);
        const dateB = new Date(b);
        return dateB.getTime() - dateA.getTime();
    })[0] : undefined

    const playerName = formattedPlayerName(
        teamName,
        `${player.first_name} ${player.last_name}`
    )

    return (
        <Option key={index} label={playerName} value={player.player_id}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                        style={{
                            backgroundColor: playersStatus[player?.player_id]?.status[latestStatusDate]?.color || '#f2f2f2',
                            height: '8px',
                            width: '8px',
                            marginRight: '8px',
                            display: 'inline-block',
                            borderRadius: '100%',
                            border: '0.1px solid black'
                        }}
                    />
                    <div>
                        <Text strong style={{ marginRight: '4px' }}>
                            {playerName}
                        </Text>
                    </div>
                </div>

                <Text type="secondary" className="player-option-secondary" style={{ fontSize: 12 }}>
                    {`Pos: ${player.position} | #${player.number} | TS: ${player.top_speed}`}
                </Text>
            </div>
        </Option>
    );
}

interface IPlayerOptions {
    player: {
        player_id: number;
        first_name: string;
        last_name: string;
        position: string;
        number: string;
        top_speed: string;
    },
    teamName: string,
    index: number,
    playersStatus: {
        [key: number]: {
            player_id: number,
            status?: {
                [key: string]: {
                    color: string;
                    date: string;
                    name: string;
                    player_id: number;
                    status_id: number;
                }
            }
        }
    }
}

export default PlayerOptions;